import MiddleBlock from "../../MiddleBlock/MiddleBlock"
import "./Footer.css"
import { NavLink } from 'react-router-dom';
import logo from "../../../images/logo.png"

export default function Footer() {
    return (
        <footer className="footer">
            <MiddleBlock>
                <div className="footer-container">
                    <img src={ logo } alt="" />

                    <div className="footer-block">
                        <h3>Menu</h3>
                        <ul className="footer-navLinks">
                            <li>
                                <NavLink 
                                    to="/about" 
                                    className={({ isActive }) => 
                                        isActive ? `link active` : `link`
                                    }
                                >
                                    O NAS
                                </NavLink>
                            </li>
                            <li>
                                <NavLink 
                                    to="/events" 
                                    className={({ isActive }) => 
                                        isActive ? `link active` : `link`
                                    }
                                >
                                    WYDARZENIA
                                </NavLink>
                            </li>
                            <li>
                                <NavLink 
                                    to="/support" 
                                    className={({ isActive }) => 
                                        isActive ? `link active` : `link`
                                    }
                                >
                                    WSPARCIE
                                </NavLink>
                            </li>
                            <li>
                                <NavLink 
                                    to="/contact" 
                                    className={({ isActive }) => 
                                        isActive ? `link active` : `link`
                                    }
                                >
                                    KONTAKT
                                </NavLink>
                            </li>
                        </ul>
                    </div>

                    <div className="footer-block">
                        <h3>Dane fundacji</h3>
                        <p>-STRUNA- Tomasz Brogowski</p>
                        <p>Kozubszczyzna 37H<br></br>21-030 Motycz</p>
                        <p>NIP: 712 262 09 60</p>
                        <p>REGON: 06030554</p>
                    </div>

                    <div className="footer-block">
                        <h3>Linki</h3>
                        <NavLink 
                            to="/privacy-policy" 
                            className="privacy-policy-link"
                        >
                            POLITYKA PRYWATNOŚCI
                        </NavLink>
                        <div className="inline-icons-links">
                            <span className="footer-icon-placeholder" aria-hidden="true">
                                <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M26 13.0326C26 5.8386 20.176 0 13 0C5.824 0 0 5.8386 0 13.0326C0 19.3403 4.472 24.5925 10.4 25.8045V16.9424H7.8V13.0326H10.4V9.77444C10.4 7.25915 12.441 5.21303 14.95 5.21303H18.2V9.12281H15.6C14.885 9.12281 14.3 9.70927 14.3 10.4261V13.0326H18.2V16.9424H14.3V26C20.865 25.3484 26 19.7965 26 13.0326Z" fill="black"/>
                                </svg>
                            </span>
                            <span className="footer-icon-placeholder" aria-hidden="true">
                                <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M18.9551 11.925L16.0551 11.15C15.6251 11.035 15.1601 11.16 14.8451 11.475L12.8001 13.52C10.0063 12.1362 7.7439 9.87377 6.3601 7.08L8.4051 5.035C8.7201 4.72 8.8451 4.255 8.7301 3.825L7.9551 0.925C7.88372 0.65988 7.72703 0.425639 7.50924 0.258454C7.29144 0.0912691 7.02466 0.000441761 6.7501 0H2.7551C1.9651 0 1.2101 0.34 0.685103 0.93C0.170103 1.51 -0.0748968 2.28 0.0201032 3.04C0.519424 7.32967 2.45257 11.3251 5.5063 14.3788C8.56004 17.4325 12.5554 19.3657 16.8451 19.865C17.2238 19.9094 17.6077 19.8731 17.9713 19.7585C18.335 19.6439 18.6703 19.4536 18.9551 19.2C19.5451 18.675 19.8851 17.92 19.8851 17.13V13.135C19.8851 12.57 19.5051 12.075 18.9601 11.925H18.9551Z" fill="black"/>
                                </svg>
                            </span>
                        </div>
                    </div>
                </div>
                <p className="footer-bottom">© 2026 Quena. Wszelkie prawa zastrzeżone.</p>
            </MiddleBlock>
        </footer>
    )
}
